import * as THREE from "three";
import { getSize128CalibrationDebugDataURL } from "../../materials/discretization/calibrationTexture";
import { uvCalibrationFragmentShader } from "../../materials/shaders/uvCalibration";
import { generateIdentityColorLUT } from "./ColorGradingLUTShader";
import { UVVertexShader } from "./UVVertexShader";

let calibrationTexture: THREE.Texture | undefined;
let calibrationMaterial: THREE.ShaderMaterial | undefined;

export function uvCalibrationMaterial(): THREE.ShaderMaterial {
  // We lazy-create the UV calibration texture and material, from a fixed 128x128 data URL.
  //
  // TODO: there's no way to wait for this texture load to complete. For example, this could
  // complicate implementing tests taking screenshots of the UV debug information.
  if (calibrationMaterial === undefined) {
    const texture = new THREE.TextureLoader().load(getSize128CalibrationDebugDataURL());
    texture.minFilter = THREE.LinearFilter;
    texture.magFilter = THREE.LinearFilter;

    calibrationTexture = texture;

    calibrationMaterial = new THREE.ShaderMaterial({
      uniforms: {
        calibrationTexture: { value: calibrationTexture },
      },
      vertexShader: UVVertexShader,
      fragmentShader: uvCalibrationFragmentShader,
      side: THREE.DoubleSide, // Ensure that the calibration texture is visible even if geometry is mirrored.
    });
  }

  return calibrationMaterial;
}

export const identityColorLUT: THREE.DataTexture = generateIdentityColorLUT();
